<template>
    <div class="OrderAmount-root">
        <info-box title="订单金额" :show-line="false">
            <!-- <template slot="mainContent">
                <a-descriptions-item label="合计">
                    <div class="item-content">
                        <p v-if="totalCost" class="info-amount">{{totalCost}}元</p>
                        <p v-else class="no-calculate-amount">暂未计算</p>
                        <div>
                            <p class="itemText">提货费/提货费1:  <span>10000</span>元</p>
                            <p class="itemText">干线费/干线费1： <span>10000</span>元</p>
                        </div> -->
                        <!-- <a-table
                            :columns="orderAmount"
                            :data-source="transportCosts"
                            :pagination="false"
                            class="amount-table"/> -->
                    <!-- </div>
                </a-descriptions-item>
            </template> -->
            <div v-if="orderDetail.status !== UnifyOrderStatusKey.BIDDING && orderDetail.status !== UnifyOrderStatusKey.CARRIER_BIDDING">
                <p v-if="orderDetail.cost !== null && orderDetail.cost !== 0 && totalCost" class="info-amount"><span class="textStyle">合计 </span>{{orderDetail.cost}}<span class="textStyle"> 元</span></p>
                <p v-else class="no-calculate-amount">暂未计算</p>
                <div>
                    <p v-for="(cos,i) in orderDetail.costs" :key="i" class="itemText">{{cos.costType}}:  <span>{{cos.cost}}</span>元</p>
                </div>
            </div>
            <div v-if="orderDetail.status === UnifyOrderStatusKey.BIDDING" class="bidding">
                <p>我的出价： 
                    <span class="myOffer">{{filterOffer()}}</span>
                    <span class="myOfferTips">
                        <img class="bgimg" src="@/assets/img/frame.png" alt="">
                        <img class="iconimg" src="@/assets/img/icon_notic.png" alt="">
                        注：合理的报价能提高司机接单成功率
                    </span>
                </p>
                <p class="item">司机报价： 
                    <span class="myOffer">{{filterTax()}}</span> 
                    <span v-if="filterStatus(biddingList.NO_BID)">
                        <span class="myOffer">无人报价</span>
                        <span class="overTime">订单超时</span>
                    </span>
                    <span v-if="filterStatus(biddingList.BIDDING)">
                        <span class="myOffer">等待报价</span>
                        <span class="timer">{{countdownSeconds()}}</span>
                    </span>
                    <span v-if="filterStatus(biddingList.NORMAL_BID)" class="discount"><img src="@/assets/img/label_best.png" alt=""></span>
                </p>
                <div>
                    <a-button v-if="showSuccess(orderDetail)" class="marStyle" type="primary" @click="transportBidConfirm">
                        同意报价
                    </a-button>
                    <a-button v-if="showOffer(orderDetail)" @click="toOffer = true">
                        重新出价
                    </a-button>
                </div>
            </div>
            <div v-if="orderDetail.status === UnifyOrderStatusKey.CARRIER_BIDDING" class="bidding">
                <p>承运商报价： <span>{{filterCost(orderDetail.cost) ? orderDetail.cost : '等待报价'}}</span> <span v-if="filterCost(orderDetail.cost)">元</span></p>
                <a-button v-if="filterCost(orderDetail.cost)" type="primary" @click="bidConfirm">
                    同意报价
                </a-button>
            </div>
        </info-box>
        <offer-dom
            v-if="toOffer" 
            :detail="orderDetail"
            @cancel="toOffer = false"
            @update="tofetch"
        />
    </div>
</template>

<script>
import InfoBox from './InfoBox.vue'
import {orderAmount} from '../tableColums.js'
import {UnifyOrderStatusKey, biddingList} from '../../constant.js'
import { bidConfirm, transportBidConfirm } from '../../api.js'
import OfferDom from '../../components/OfferDom.vue'

export default {
    name: 'OrderAmount',
    components: {
        InfoBox,
        OfferDom,
    },
    props: {
        orderDetail: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            orderAmount,
            UnifyOrderStatusKey,
            toOffer: false,
            biddingList,
        }
    },
    computed: {
        transportCosts() {
            const transportCosts = this.orderDetail?.transportCosts ?? []
            return transportCosts.map((item, index) => {
                return {
                    key: item.carrierTenantId || index,
                    costType: item.costType,
                    cost: item.cost.toFixed(2)
                }
            })
        },
        totalCost() {
            return this.transportCosts.reduce((prev, next) => {
                return prev + parseFloat(next.cost, 10)
            }, 0).toFixed(3)
        },
    },
    created () {},
    mounted () {},
    methods: {
        countdownSeconds() {
            const countdownSeconds = this.orderDetail?.negotiationBid?.countdownSeconds || 1000000
            if(countdownSeconds){
                let D = countdownSeconds * 1 / 86400
                let h = countdownSeconds * 1 % 86400 / 3600
                let m = countdownSeconds * 1 % 86400 % 3600 / 60
                D = D.toFixed(0)
                h = h.toFixed(0)
                m = m.toFixed(0)
                return `剩${D}天${h}时${m}分`
            }
            return ''
        },
        transportBidConfirm(){
            transportBidConfirm({
                unifyOdrNo: this.orderDetail.unifyOrderNo,
                bidId: this.orderDetail?.negotiationBid?.bidId
            }).then(() => {
                this.$message.success('提交成功')
                this.$router.push('/order/manage')
            })
        },
        tofetch(){
            this.toOffer = false
            this.$emit('tofetch')
        },
        showOffer(rowData){
            return rowData.negotiationBid && (rowData.negotiationBid.bidStatus === biddingList.NO_BID || rowData.negotiationBid.bidStatus === biddingList.DISABLED || rowData.negotiationBid.bidStatus === biddingList.NORMAL_BID)
        },
        showSuccess(rowData){
            return rowData.negotiationBid && rowData.negotiationBid?.bidStatus === biddingList.NORMAL_BID
        },
        filterCost(data){
            return !!data
        },
        bidConfirm(){
            bidConfirm(this.orderDetail.unifyOrderNo).then(() => {
                this.$message.success('提交成功')
                this.$router.push('/order/manage')
            })
        },
        filterOffer(){
            return this.orderDetail?.negotiationBid?.customerBidCost ? `${this.orderDetail?.negotiationBid?.customerBidCost}元` : ''
        },
        filterTax(){
            return this.orderDetail?.negotiationBid?.driverBidCostTax ? `${this.orderDetail?.negotiationBid?.driverBidCostTax}元` : ''
        },
        filterStatus(status) {
            return this.orderDetail?.negotiationBid?.bidStatus === status;
        },
    },
}
</script>

<style lang="less" scoped>
.OrderAmount-root{
    position: relative;
}
.info-amount {
    color: #FF4830;
    font-size: 18px;
    font-weight: bold;
    margin-top: 10px;
}
.no-calculate-amount {
    color: #999;
}
.amount-table {
    width: 400px;
}
/deep/ .ant-table-row-hover td{
    background: #fff !important;
}
/deep/ .ant-table-row{
    &:hover td{
        background: #dff7eb !important;
    }
}
/deep/ .ant-table-placeholder{
    z-index: 0 !important;
}
.itemText{
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    color: #606266;
    line-height: 20px;
    margin-right: 23px;
    margin-top: 16px;
    span{
        color: #171717;
        font-weight: 600;
    }
}
.textStyle{
    font-size: 14px;
    color: #606266;
    font-weight: 400;
}
.bidding{
    p{
        font-size: 14px;
        span{
            font-size: 18px;
            color: #F56C6C;
        }
    }
    .item{
        margin-top: 23px;
    }
    button{
        margin-top: 24px;
    }
    .myOffer{
        font-size: 17px;
        color: #171717;
        font-weight: bold;
    }
    .timer{
        display: inline-block;
        width: 114px;
        height: 24px;
        line-height: 24px;
        border-radius: 12px;
        border: 1px solid #C9CBCE;
        font-size: 12px;
        color: #323233;
        text-align: center;
        margin-left: 13px;
    }
    .myOfferTips{
        display: inline-block;
        position: relative;
        font-size: 12px;
        color: #FB9432;
        height: 24px;
        line-height: 28px;
        z-index: 2;
        padding: 0 17px;
        margin-left: 24px;
        .bgimg{
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
        }
        .iconimg{
            width: 14px;
            height: 14px;
            vertical-align: middle;
        }
    }
    .discount{
        margin-left: 8px;
    }
    .overTime{
        display: inline-block;
        width: 66px;
        height: 24px;
        line-height: 24px;
        border-radius: 12px;
        border: 1px solid #ED4934;
        font-size: 12px;
        color: #ED4934;
        text-align: center;
        margin-left: 13px;
    }
}
.marStyle{
    margin-right: 24px;
}
</style>